import axios from "@/utils/request.js";
import qs from "qs"
const currentUrl = window.location.href;
var pos = window.location.pathname
window.baseUrl = currentUrl.substring(0, currentUrl.indexOf(pos))
var baseUrl = process.env.NODE_ENV === 'production' ? window.baseUrl : process.env.VUE_APP_BASE_API
//文件库储存空间
export const getStoryOverview = (params) =>
    axios({
        url: '/api/web-basic/configuration/storage/overview',
        method: 'post',
        params
    })
// 文件上传
const uploadChunk = (params) => axios({
  url: '/api/web-manager/file/manager/upload/chunk',
  method: 'post',
  data: params
})
// 切片校验
const chunkChunk = (params) => axios({
  url: '/api/web-manager/file/manager/chunk/check',
  method: 'post',
  data: params
})


// 获取子文件夹(全返)
const fileFolder = (params) => axios.get('/api/web-manager/file/folder/allchild', {
  params
})

//  获取文件预览路径
const filePerviewPath = (data) => {
  // let url = baseUrl + `/api/web-manager/file/manager/download/${data.fileObjId}/${data.downType}`
  let url = baseUrl + `/api/web-manager/file/manager/redirect/${data.fileObjId}/${data.downType}`
  return url
};
//  获取文件下载路径
const filePath = (data) => {
  let url = baseUrl + `/api/web-manager/file/manager/path/${data.fileObjId}/${data.downType}`
  return url
};
// 获取文件转码地址路径
const fileRealPath = (data) => {
  return axios.get(`/api/web-manager/file/manager/path/${data.fileObjId}/${data.downType}`)
}
// 获取文件重定向地址
const filePathRedirect = (data) => {
  let url = baseUrl + `/api/web-manager/file/manager/redirect/${data.fileObjId}/${data.downType}`
  if (data.fileObjId) return url
  else return ''
};

// 根据类型获取索引
const dictionaryType = (params) => {
  return axios.get(`/api/web-basic/common/dictionary/type/${params}`)
}
// 根据类型获取索引
const dictionaryList = (params) => {
  return axios.get(`/api/web-basic/common/dictionary/list/`, {
    params
  })
}
// 获取配置列表

const configurationList = (params) => axios.get('/api/web-basic/configuration/manager/tenant/list', {
  params
})
// 设置系统配置
const configurationSet = (params) => axios({
  url: '/api/web-basic/configuration/manager/set',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})

// 获取租户相关配置组
const configurationGroup = (params) => axios.get('/api/web-basic/configuration/manager/tenant/group', {
  params
})
//获取后台App内获取总下载量
const getAppData = (params) => axios.get('/api/web-terminal/project/manager/down/total', {
  params
})
//获取文件绝对路径
const getUrl = (data) => axios.get(`/api/web-manager/file/manager/absPath/${data.id}/${data.type}`)
export const getPrivateId = () =>
  axios.get("/api/web-manager/file/manager/get/private");

// 添加租户配置



const configurationAdd = (params) => axios({
  url: `/api/web-basic/configuration/manager/add/${params.comConfType}`,
  method: 'post',
  data: params.list
})

// 分页获取报选题列表
const subjectPage = (params) =>
  axios({
    url: '/api/web-clue/subject/manager/page',
    method: 'get',
    params
  })
// 获取审批历史


// 获取稿件日志列表
const approveHistory = (params) => {
  return axios.get(`/api/web-content/manuscript/approve/history`, {
    params
  })
}

// 获取CMS地址

const configurationCMS = (params) => {
  return axios.get(`/api/web-conf/configuration/manager/cms`, {
    params
  })
}
// 精确获取系统配置
/*
  
    
     
    
*/
/**
 * 浏览器判断模块
 * @params
  * @comConfKey  配置字段名
  * @comConfType 配置类型：0为系统配置，1为平台配置，2为文件库配置，6屏蔽词配置，10为中视云APP统一配置，11为中视云APP IOS配置，12为中视云APP ANDORID配置，14为订阅号配置
  * @webTenId 租户ID
 */
const configurationManagerSingle = (params) => {
  return axios.get(`/api/web-conf/configuration/manager/single`, {
    params
  })
}
//
const tenantDispose = (params) => {
  return axios.get(`/api/web-conf/configuration/manager/tenant/json`, {
    params
  })
}
//获取租户相关配置JSON
//URL文件入库
const getUpUrl = (data) => axios({
  url: `/api/web-manager/file/manager/import`,
  method: 'post',
  data: qs.stringify(data)
});


// 智能校对 
// Word转Html
const word2html = (data) => axios({
  url: `/api/web-basic/intellgence/word2html`,
  method: 'post',
  data: data
});
// 内容查重

const duplicate = (data) => axios({
  url: `/api/web-basic/intellgence/duplicate`,
  method: 'post',
  data: data
});


//获取懒加载文件夹树
const getFiletree = (params) =>
  axios({
    url: '/api/web-manager/file/folder/group/child',
    method: 'get',
    params
  })


  // 获取租户信息  ---- 用于获取logo图片展示
  const getTenantDetail = (params)=>axios({
    url: '/api/web-basic/tenant/manager/picjson',
    method: 'get',
    params
  })
export {
  uploadChunk,
  chunkChunk,
  fileFolder,
  filePath,
  filePathRedirect,
  dictionaryType,
  dictionaryList,
  filePerviewPath,
  configurationList,
  configurationSet,
  configurationGroup,
  configurationAdd,
  subjectPage,
  approveHistory,
  configurationCMS,
  configurationManagerSingle,
  getUpUrl,
  word2html,
  duplicate,
  fileRealPath,
  getAppData,
  tenantDispose,
  getUrl,
  getFiletree,
  getTenantDetail
}